var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 1.66675C8.35215 1.66675 6.74099 2.15549 5.37058 3.07117C4.00017 3.98685 2.93206 5.28833 2.30133 6.81105C1.6706 8.33377 1.50558 10.0093 1.82712 11.6258C2.14866 13.2423 2.94233 14.7272 4.10777 15.8926C5.27321 17.0581 6.75807 17.8517 8.37458 18.1733C9.99108 18.4948 11.6666 18.3298 13.1894 17.6991C14.7121 17.0683 16.0136 16.0002 16.9292 14.6298C17.8449 13.2594 18.3337 11.6483 18.3337 10.0001C18.3311 7.79073 17.4523 5.67259 15.8901 4.11034C14.3278 2.5481 12.2097 1.6693 10.0003 1.66675ZM13.9692 8.54087L9.26791 13.028C9.14837 13.1418 8.98969 13.2052 8.8247 13.2052C8.6597 13.2052 8.50102 13.1418 8.38149 13.028L6.03148 10.7845C5.9087 10.6669 5.83763 10.5053 5.83387 10.3354C5.8301 10.1654 5.89396 10.0009 6.01141 9.87795C6.12886 9.75502 6.2903 9.68374 6.46026 9.67976C6.63023 9.67579 6.79482 9.73943 6.9179 9.85673L8.8247 11.6778L13.0828 7.61314C13.2058 7.49584 13.3704 7.4322 13.5404 7.43618C13.7104 7.44015 13.8718 7.51143 13.9892 7.63436C14.1067 7.75728 14.1706 7.9218 14.1668 8.09177C14.163 8.26174 14.092 8.42327 13.9692 8.54087Z",
    fill: "#38B048"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/confirm.4f3027c2.svg";
export { ForwardRef as ReactComponent };